module.exports = __webpack_public_path__ + "img/home-block-3-2.531002e2.jpg";